<!-- <ion-header> -->
    <ion-card class="headmodal">
        <span class="titlemodal">
            {{"about" | translate}}
        </span>
        <ion-button class="close-button" (click)="closeModal()">
            <ion-icon color="dark" name="close-outline"></ion-icon>
        </ion-button>
    </ion-card >
<!-- </ion-header> -->

<ion-card class="contentcard bg-light">
    <ng-container *ngIf="platform.isRTL;else ltrShow">
        <div [innerHTML]="content_ar"></div>
    </ng-container>
    <ng-template #ltrShow>
        <div [innerHTML]="content"></div>
    </ng-template>
</ion-card>